import React, { FC } from "react";
import { Card, Col, Row, Tag } from "antd";
import { useParams } from "react-router-dom";

import InstrumentInfo from "../../../components/CI10/InstrumentInfo";
import InstrumentTabs from "../../../components/CI10/InstrumenTabs";
import useHttpGet from "../../../hooks/useHttpGet";
import { IResultResponse } from "../../../models/response/result.model";
import { APIRoutes } from "../../../http";
import { IInstrumentExtended } from "../../../models/instrument-extended.model";
import InstrumentNews from "../../../components/CI10/InstrumentNews";

const ViewInstrument: FC = () => {
  const { id } = useParams();

  const { fetchedData, loading } = useHttpGet<
    IResultResponse<IInstrumentExtended>
  >(`${APIRoutes.INSTRUMENTS}/${id}`, {
    defaultValue: { result: {} as IInstrumentExtended },
  });

  return (
    <Row justify="center" align="top">
      <Col xs={24} sm={24} md={20}>
        <Card
          className="custom-card-1"
          title={
            <div className="d-flex align-items-center">
              <span className={fetchedData.result.image}></span>
              <span className="fs-36">{fetchedData.result?.name}</span>
              <Tag>{fetchedData.result.ticker}</Tag>

              <img src={fetchedData.result?.image} style={{ maxHeight: '40px', marginRight: '5px' }} />
            </div>
          }
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col xs={24} sm={24} md={9}>
              <InstrumentInfo data={fetchedData.result} loading={loading} />
            </Col>
            <Col xs={24} sm={24} md={15}>
              <InstrumentTabs />
            </Col>
            <Col xs={24} sm={24} md={24}>
              <InstrumentNews name={fetchedData?.result?.name} />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default ViewInstrument;
